'use client';

import useSWR from 'swr';
import { API_URLS, SWR_REQUEST_DEFAULTS } from '@/lib/api/config';
import {
  TypeMediaAssetsResponseData,
  TypeMediaCollection,
} from '@/lib/api/playbackService/types';

export default function useMediaCollectionMediaAssets(
  anchor: string,
  type: TypeMediaCollection,
) {
  const { data, error, mutate } = useSWR<TypeMediaAssetsResponseData, Error>(
    `${API_URLS.PLAYBACK_SERVICE_PROXY}/media_collections/${type}/${anchor}/media_assets`,
    { ...SWR_REQUEST_DEFAULTS },
  );

  return {
    data,
    loading: !error && !data,
    error,
    mutate,
  };
}
